import { Link, useStore, useRouter, LoginForm } from '@/core'
import { legacyRoute } from '@u/legacy-route'
import { fetchUserInfo } from '@u/drf/auth'
import { GoogleButton } from '@c/auth-app/google-button'
import { MicrosoftButton } from '@c/auth-app/microsoft-button'
import { useTranslation } from 'react-i18next'
import authStyles from '@c/auth-layout/style.module.less'

export const LoginPage = () => {
  const { t, i18n } = useTranslation()
  const router = useRouter()
  const store = useStore()
  const [, setLanguage] = store.use(['language'])
  const [next] = store.use(['next'])

  return (
    <>
      <div className={authStyles.formHeader}>
        <h1>{t('auth.loginPage.title')}</h1>
        <p>Login to your account.</p>
      </div>
      
      <GoogleButton />
      <MicrosoftButton />

      <div style={{ margin: '1.5rem 0', display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={{ flex: 1, height: '1px', background: '#D9E8F5' }} />
        <span style={{ fontSize: '13px', color: '#6B7B8D', fontWeight: 500 }}>OR</span>
        <div style={{ flex: 1, height: '1px', background: '#D9E8F5' }} />
      </div>

      <LoginForm
        onSuccess={(info) => {
          const preferredLanguage = info?.profile?.preferredLanguage || 'en'
          setLanguage(preferredLanguage)
          i18n.changeLanguage(preferredLanguage)
          if (next.route) {
            router.push(next.route)
          } else if (next.string) {
            legacyRoute(next.string)
          } else if (info.legacyNextUrl) {
            legacyRoute(info.legacyNextUrl)
          } else if (info.nextUrl) {
            router.push({ name: info.nextUrl })
          } else if (info.legacyHomeUrl) {
            legacyRoute(info.legacyHomeUrl)
          } else {
            router.push({ name: info.homeUrlName })
          }
        }}
        fetchUserInfo={fetchUserInfo}
      />

      <div style={{ marginTop: '1.5rem', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <p style={{ fontSize: '14px' }}>
          <Link name="forgotPassword" style={{ color: '#2B9FE8' }}>
            {t('auth.loginWithEmailPage.forgot_password')}
          </Link>
        </p>
        {/* <p style={{ fontSize: '14px' }}>
          <Link name="nonprofitLogin" style={{ color: '#2B9FE8' }}>
            {t('auth.loginPage.nonprofit_login_link')}
          </Link>
        </p> */}
      </div>
    </>
  )
}
